module.exports = __webpack_public_path__ + "d623f29a56e2f27129ce5331aadac71b.png";